import { ParsedUrlQuery } from 'querystring';
import { stepIsValid as brandingRouteValidation } from '../branding-design/config';
import { stepIsValid as websitwRouteValidation } from '../website/config';

function routeValid(query: ParsedUrlQuery, validationFn: (stepIndex: number) => boolean): boolean {
    const [step] = query.params || [];

    if (!step || step === 'recommendation') {
        return true;
    }

    const stepIndex = parseInt(step, 10) - 1;

    return validationFn(stepIndex);
}

export function brandingRouteValid(query: ParsedUrlQuery): boolean {
    return routeValid(query, brandingRouteValidation);
}

export function websiteRouteValid(query: ParsedUrlQuery): boolean {
    return routeValid(query, websitwRouteValidation);
}
